import { drawerAtom } from "@components/templates/state"
import { useAtom } from "jotai"
import { HTMLAttributes, useEffect, useState } from "react"
import { FaXmark } from "react-icons/fa6"

export interface ModalWrapperProps extends HTMLAttributes<HTMLDivElement> {
    isOpen: boolean,
    onClose: () => void
}

export const ModalSideWrapper = ({ children, className, isOpen, onClose, ...rest }: ModalWrapperProps) => {
    const [drawer, setDrawer] = useAtom(drawerAtom)

    // logger.debug(drawer)
    useEffect(() => {
        setDrawer(isOpen)
    }, [isOpen])

    const close = () => {
        setDrawer(false)
        onClose?.()
    }

    return <>
        <div
            aria-label="close sidebar"
            className={`fixed inset-0 z-40 bg-black/30 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
            onClick={close}
        />
        <div
            className={`fixed top-0 right-0 z-50 h-full bg-base-100 shadow-xl transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}
                w-full max-w-md md:w-2/5 md:rounded-l-2xl md:max-w-md p-4 flex flex-col
                ${className ?? ''}`}
            style={{ borderTopLeftRadius: '1.5rem', borderBottomLeftRadius: '1.5rem' }}
            {...rest}
        >
            <div className="sticky top-0 z-10 bg-base-100 flex justify-end pb-2">
                <button className="btn btn-ghost" onClick={close}>
                    <FaXmark className="w-6 h-6" />
                </button>
            </div>
            <div className="flex-1 overflow-y-auto">
                {children}
            </div>
        </div>
    </>
}